export const TITLE_NOT_PRODUCTION: string = 'text-medium-subtitle';
export const TITLE_IN_PRODUCTION: string = 'text-medium-orange bold';
export const TITLE_NOT_PRODUCTION_SMALL: string = 'text-xsmall-subtitle';
export const TITLE_IN_PRODUCTION_SMALL: string = 'text-xsmall-orange bold';
